import { SkillResourceGetSupportSkillsSkillStatesQuery$data } from '../graphQLOperations/__generated__/SkillResourceGetSupportSkillsSkillStatesQuery.graphql';
import { SkillAncestriesId } from '../models/SkillAncestries';

export const getHighAndMediumSupportSkillsFromQuery = (
  supportedSkillsQuery: SkillResourceGetSupportSkillsSkillStatesQuery$data,
) => {
  const highSupportSkills = supportedSkillsQuery.supportSkillsSkillStates
    .filter(el => el.skillRelevance.id === SkillAncestriesId.HIGH)
    .map(element => {
      return element.studentSkill;
    });

  const mediumSupportSkills = supportedSkillsQuery.supportSkillsSkillStates
    .filter(el => el.skillRelevance.id === SkillAncestriesId.MEDIUM)
    .map(element => {
      return element.studentSkill;
    });

  return { highSupportSkills, mediumSupportSkills };
};
